import gql from "graphql-tag";

import { Company, Fragment, User } from "../types";

import { DocumentFragment, DOCUMENT_FRAGMENT } from "./Document";
import { GroupFragment, GROUP_FRAGMENT } from "./Group";
import {
  MadFragment,
  MadFullFragment,
  MAD_FRAGMENT,
  MAD_FULL_FRAGMENT,
} from "./Mad";

export const USER_MAD_FRAGMENT = gql`
  fragment UserMadFragment on User {
    id
    slug
    name
    avatar
    email
    notes
    role
    canAddDocument
    documents {
      ...DocumentFragment
    }
    createdAt
    company {
      id
      name
    }
    groups {
      ...GroupFragment
    }
    madsAsTalent {
      ...MadFragment
    }
    madsAsReferent {
      ...MadFragment
    }
  }
  ${GROUP_FRAGMENT}
  ${MAD_FRAGMENT}
  ${DOCUMENT_FRAGMENT}
`;

export type UserMadFragment = Fragment<
  User,
  Pick<
    User,
    | "id"
    | "slug"
    | "email"
    | "name"
    | "notes"
    | "avatar"
    | "createdAt"
    | "updatedAt"
    | "role"
    | "canAddDocument"
  > & {
    documents: DocumentFragment[];
    company: Pick<Company, "id" | "name">;
    groups: GroupFragment[];
    madsAsTalent: MadFragment[];
    madsAsReferent: MadFragment[];
    // groupsUser: GroupUserMinimalFragment[];
  }
>;

export const USER_MAD_FULL_FRAGMENT = gql`
  fragment UserMadFullFragment on User {
    id
    slug
    name
    avatar
    email
    notes
    canInsert
    canAddDocument
    role
    documents {
      ...DocumentFragment
    }
    createdAt
    company {
      id
      name
    }
    groups {
      ...GroupFragment
    }
    madsAsTalent {
      ...MadFullFragment
    }
    madsAsReferent {
      ...MadFragment
    }
  }
  ${MAD_FRAGMENT}
  ${GROUP_FRAGMENT}
  ${MAD_FULL_FRAGMENT}
  ${DOCUMENT_FRAGMENT}
`;

export type UserMadFullFragment = Fragment<
  User,
  Pick<
    User,
    | "id"
    | "slug"
    | "email"
    | "name"
    | "notes"
    | "avatar"
    | "createdAt"
    | "updatedAt"
    | "canInsert"
    | "canAddDocument"
    | "role"
  > & {
    documents: DocumentFragment[];
    company: Pick<Company, "id" | "name">;
    groups: GroupFragment[];
    madsAsTalent: MadFullFragment[];
    madsAsReferent: MadFragment[];
  }
>;
